<template>
  <div class="flex flex-wrap complete-menu">
    <!-- flex flex-column-->
    <MenuItem
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :icon="item.icon"
      :text="item.title"
      :path-name="item.pathName"
      :path="item.path"
    />
  </div>
</template>

<script>

import { computed } from 'vue';
import MenuItem from '@/components/menu/MenuItem';
import { menuItems } from '@/mixins/utils';

export default {
  components: { MenuItem },
  setup () {
    const items = computed(() => menuItems('Entry'));

    return { items };
  }
};
</script>

<style>
.complete-menu {
  padding: 0rem 2rem; /*px3*/
}

#menu-mobile.complete-menu {
  padding: 0rem;
  -webkit-box-flex:1;
  -webkit-flex:1 1 auto;
      -ms-flex:1 1 auto;
          flex:1 1 auto;
  min-width:0;
  min-height:0;
}

@media (min-width: 52em) {
  .complete-menu {
    padding: 0rem 0rem;
    margin: 0rem 0rem;
  }
}
</style>
